// extracted by mini-css-extract-plugin
module.exports = {"Section___margined":"ContentSection_Section___margined__D7grb","Section___centered":"ContentSection_Section___centered__eUf7Y"};